export default "__VITE_ASSET__IYN6JJWx__"